'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { useLenis } from 'lenis/react';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { Glyphs } from '~/components/button';
import { Link } from '~/components/link';
import { useGlobalTransitionRefs } from '~/components/page-transition/context';
import { Squares } from '~/components/squares';
import { useDeviceDetection } from '~/hooks/use-device-detection';
import { useStore } from '~/libs/store';
import s from './header.module.css';
import { MobileMenu } from './mobile-menu/mobile-menu';

// Define NAVITEMS here
const NAVITEMS = [{
  label: 'Open Source',
  href: 'https://github.com/darkroomengineering',
  order: 1
}, {
  label: 'Work',
  href: '/work',
  order: 2
}, {
  label: 'About',
  href: '/about',
  order: 3
}, {
  label: 'Read',
  href: '/read',
  order: 4
},
// {
//   label: 'Store',
//   href: '/store',
//   order: 5,
// },
{
  label: 'Contact',
  href: '/contact',
  order: 6
}, {
  label: 'Become an open source sponsor',
  href: 'https://github.com/sponsors/darkroomengineering',
  order: 7
}];
export function Header() {
  const $ = _c(36);
  const lenis = useLenis();
  const {
    isMobile
  } = useDeviceDetection();
  const isFooterFullyInView = useStore(_temp);
  const hasAppeared = useStore(_temp2);
  const setHasAppeared = useStore(_temp3);
  const headerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      header: headerRef
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useGlobalTransitionRefs(t0);
  const pathname = usePathname();
  const [appearStep, setAppearStep] = useState(-2);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const squaresRefs = useRef(t1);
  let t2;
  let t3;
  if ($[2] !== hasAppeared || $[3] !== lenis || $[4] !== setHasAppeared) {
    t2 = () => {
      const done = () => {
        setAppearStep(4);
        setHasAppeared(true);
        lenis?.start();
      };
      if (!lenis || hasAppeared) {
        return;
      }
      lenis.stop();
      const interval = setInterval(() => {
        for (const square of squaresRefs.current) {
          square?.animate(1000, {
            duration: 0
          });
        }
      }, 100);
      const timeout = setTimeout(() => {
        setAppearStep(-1);
      }, 1000);
      const timeout0 = setTimeout(() => {
        setAppearStep(0);
      }, 2000);
      const timeout1 = setTimeout(() => {
        setAppearStep(1);
      }, 3000);
      const timeout2 = setTimeout(() => {
        setAppearStep(2);
      }, 4000);
      const timeout3 = setTimeout(() => {
        setAppearStep(3);
        lenis?.start();
      }, 5000);
      const timeout4 = setTimeout(() => {
        done();
        clearInterval(interval);
      }, 6000);
      return () => {
        clearTimeout(timeout);
        clearTimeout(timeout0);
        clearTimeout(timeout1);
        clearTimeout(timeout2);
        clearTimeout(timeout3);
        clearTimeout(timeout4);
        clearInterval(interval);
        lenis?.start();
      };
    };
    t3 = [lenis, hasAppeared, setHasAppeared];
    $[2] = hasAppeared;
    $[3] = lenis;
    $[4] = setHasAppeared;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  const t4 = appearStep > -2 && s.appear0;
  const t5 = appearStep > -1 && s.appear1;
  const t6 = appearStep > 0 && s.appear2;
  const t7 = appearStep > 1 && s.appear3;
  const t8 = appearStep > 2 && s.appear4;
  const t9 = appearStep > 3 && s.appear5;
  const t10 = isFooterFullyInView && s.hidden;
  let t11;
  if ($[7] !== t10 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t11 = cn(s.wrapper, t4, t5, t6, t7, t8, t9, t10, "z-20");
    $[7] = t10;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cn(s.header, "absolute top-0 left-0 right-0 p uppercase dr-layout-grid-inner h-header-height bg-primary");
    t13 = cn("sp-8 h-full dt:spy-6 dt:spx-8 flex items-center justify-center bg-contrast absolute left-safe", s.left);
    $[15] = t12;
    $[16] = t13;
  } else {
    t12 = $[15];
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Glyphs className={cn(s.glyphs, "flex items-center mobile-only")} />;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = node => {
      squaresRefs.current[0] = node;
    };
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== isMobile) {
    t16 = <div className={t13}>{t14}<Squares className="sh-10 desktop-only" single={isMobile} ref={t15} /></div>;
    $[19] = isMobile;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn("relative col-start-2 col-end-4 dt:col-start-3 dt:col-end-8 h-full flex justify-center items-center dt:grid dt:grid-cols-5 dt:gap-gap");
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Link className={cn(s.logo, "cta spx-8 flex items-center h-full bg-contrast cta-hover", "dt:col-span-2 dt:justify-self-start")} href="/">darkroom.engineering</Link>;
    t19 = cn(s.nav, "flex desktop-only col-span-2");
    $[22] = t18;
    $[23] = t19;
  } else {
    t18 = $[22];
    t19 = $[23];
  }
  let t20;
  if ($[24] !== pathname) {
    t20 = NAVITEMS.filter(_temp4).sort(_temp5).map(t21 => {
      const {
        label,
        href,
        order
      } = t21;
      const isActive = pathname === href;
      return <Link key={order} className={cn("cta spy-4 spx-8 flex items-center bg-contrast cta-hover", isActive && s.active)} href={href}>{label}</Link>;
    });
    $[24] = pathname;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] !== t20) {
    t21 = <div className={t17}>{t18}<nav className={t19}>{t20}</nav></div>;
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = cn(s.right, "sw-28 sh-28 dt:h-fit dt:w-fit dt:spy-6 dt:spx-8 dt:flex bg-contrast dt:items-center dt:justify-center absolute right-safe");
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className={t22}><Squares mirrored={true} className="sh-10 desktop-only" ref={node_0 => {
        squaresRefs.current[1] = node_0;
      }} /><MobileMenu navItems={NAVITEMS} className="mobile-only" /></div>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t16 || $[31] !== t21) {
    t24 = <header className={t12}>{t16}{t21}{t23}</header>;
    $[30] = t16;
    $[31] = t21;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== t11 || $[34] !== t24) {
    t25 = <div ref={headerRef} className={t11}>{t24}</div>;
    $[33] = t11;
    $[34] = t24;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  return t25;
}
function _temp5(a, b) {
  return a.order - b.order;
}
function _temp4(item) {
  return !item.href.startsWith("http");
}
function _temp3(state_1) {
  return state_1.setHasAppeared;
}
function _temp2(state_0) {
  return state_0.hasAppeared;
}
function _temp(state) {
  return state.isFooterFullyInView;
}